/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteUserSessionIssuerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteUserSessionIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteUserSessionIssuerSecurity = {
  option1?: DeleteUserSessionIssuerSecurityOption1 | undefined;
  option2?: DeleteUserSessionIssuerSecurityOption2 | undefined;
};

export type DeleteUserSessionIssuerRequest = {
  /**
   * The user_session_issuer id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteUserSessionIssuerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteUserSessionIssuerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DeleteUserSessionIssuerSecurityOption1$Outbound,
    DeleteUserSessionIssuerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteUserSessionIssuerSecurityOption1ToJSON(
  deleteUserSessionIssuerSecurityOption1:
    DeleteUserSessionIssuerSecurityOption1,
): string {
  return JSON.stringify(
    DeleteUserSessionIssuerSecurityOption1$outboundSchema.parse(
      deleteUserSessionIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteUserSessionIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteUserSessionIssuerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DeleteUserSessionIssuerSecurityOption2$Outbound,
    DeleteUserSessionIssuerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function deleteUserSessionIssuerSecurityOption2ToJSON(
  deleteUserSessionIssuerSecurityOption2:
    DeleteUserSessionIssuerSecurityOption2,
): string {
  return JSON.stringify(
    DeleteUserSessionIssuerSecurityOption2$outboundSchema.parse(
      deleteUserSessionIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteUserSessionIssuerSecurity$Outbound = {
  Option1?: DeleteUserSessionIssuerSecurityOption1$Outbound | undefined;
  Option2?: DeleteUserSessionIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteUserSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  DeleteUserSessionIssuerSecurity$Outbound,
  DeleteUserSessionIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteUserSessionIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteUserSessionIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteUserSessionIssuerSecurityToJSON(
  deleteUserSessionIssuerSecurity: DeleteUserSessionIssuerSecurity,
): string {
  return JSON.stringify(
    DeleteUserSessionIssuerSecurity$outboundSchema.parse(
      deleteUserSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type DeleteUserSessionIssuerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteUserSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  DeleteUserSessionIssuerRequest$Outbound,
  DeleteUserSessionIssuerRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteUserSessionIssuerRequestToJSON(
  deleteUserSessionIssuerRequest: DeleteUserSessionIssuerRequest,
): string {
  return JSON.stringify(
    DeleteUserSessionIssuerRequest$outboundSchema.parse(
      deleteUserSessionIssuerRequest,
    ),
  );
}
